import { render, staticRenderFns } from "./AddHouseRelecantPhoto.vue?vue&type=template&id=d2490d8e&scoped=true&"
import script from "./AddHouseRelecantPhoto.vue?vue&type=script&lang=js&"
export * from "./AddHouseRelecantPhoto.vue?vue&type=script&lang=js&"
import style0 from "./AddHouseRelecantPhoto.vue?vue&type=style&index=0&id=d2490d8e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2490d8e",
  null
  
)

export default component.exports